// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"1474":"my-posts-page-modals","4061":"post-actions"}[chunkId] || chunkId) + ".chunk.min.css";
};